import { render, staticRenderFns } from "./PcQrtyTable.vue?vue&type=template&id=03fe2c60&"
import script from "./PcQrtyTable.vue?vue&type=script&lang=js&"
export * from "./PcQrtyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports